Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const cron$1 = require('./cron.js');
const nodeCron = require('./node-cron.js');
const nodeSchedule = require('./node-schedule.js');

/** Methods to instrument cron libraries for Sentry check-ins */
const cron = {
  instrumentCron: cron$1.instrumentCron,
  instrumentNodeCron: nodeCron.instrumentNodeCron,
  instrumentNodeSchedule: nodeSchedule.instrumentNodeSchedule,
};

exports.cron = cron;
//# sourceMappingURL=index.js.map
